import { useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { hasPlgSession, isPlgSetupOpen } from "plg/auth/plgTokenStore";
import { HIRE_ROUTES } from "plg/routes";
import useRecheckOnRestore from "plg/shell/useRecheckOnRestore";

const setupDone = () => hasPlgSession() && !isPlgSetupOpen();

/**
 * The setup steps and the welcome page: for a new sign-up (signed out, with a sign-up token) and for a
 * signed-in customer whose setup is still open (the account exists from the first step). A customer who
 * finished setup is replaced to /hire/home. Decided once on arrival: the welcome page closes setup itself
 * and then moves on. A page restored from the back/forward cache is checked again.
 */
function PlgSetupRoute({ children }: { children: ReactNode }) {
  const [done] = useState(setupDone);
  useRecheckOnRestore(setupDone, HIRE_ROUTES.home);
  if (done) return <Navigate to={HIRE_ROUTES.home} replace />;
  return <>{children}</>;
}

export default PlgSetupRoute;
